import APIService from './api';

class ModelService {
  constructor() {
    this.api = APIService;
  }

  /**
   * @param {String} lang
   * @template ‘EN CN VN KH ID’
   */
  // 获取导航菜单
  // lang
  async navList(data) {
    return this.api.get(`/nav/menu`, data);
  }
  // 获取支持语言信息
  async languageList() {
    return this.api.get(`/language/list`);
  }
  // 获取所有广告列表
  // lang
  async getbannerList(data) {
    return this.api.get(`/board/list`, data);
  }
  // 获取单个广告
  // id
  async getbannerInfo(data) {
    return this.api.get(`/board/get`, data);
  }
  // 获取单个广告图片信息
  // lang & adId
  async getbanner(data) {
    return this.api.get(`/board/pictures`, data);
  }
  // 获取页面Content信息列表
  // lang
  async getContentList(data) {
    return this.api.get(`/content/list`, data);
  }
  // 获取页面Content分页列表
  // lang
  async getContentPage(data) {
    return this.api.get(`/content/page`, data);
  }
  // 获取页面Content信息
  // id
  async getPageInfo(data) {
    return this.api.get(`/content/get`, data);
  }
  // 获取用户公司信息
  // lang
  async getCompanyInfo(data) {
    return this.api.get(`/company/get`, data);
  }
  // 获取所有Config信息列表
  async getConfigList() {
    return this.api.get(`config/list`);
  }
  // 获取所有Config信息
  // id
  async getConfigInfo(data) {
    return this.api.get(`/config/get`, data);
  }
  // 获取所有Factory信息列表
  // lang
  async getFactoryList(data) {
    return this.api.get(`factory/list`, data);
  }
  // 获取所有Factory信息
  // id
  async getFactoryInfo(data) {
    return this.api.get(`/factory/get`, data);
  }
  // 获取所有FactoryEmployee信息列表
  // lang
  async getFactoryEmployeeList(data) {
    return this.api.get(`/factory/employee/list`, data);
  }
  // 获取FactoryEmployee分页列表
  // lang
  async getFactoryEmployeePage(data) {
    return this.api.get(`/factory/employee/page`, data);
  }
  // 获取所有FactoryEmployee信息
  // id
  async getFactoryEmployeeInfo(data) {
    return this.api.get(`/factory/employee/get`, data);
  }
  // 获取所有Gallery信息列表
  // lang id=0
  async getgalleryList(data) {
    return this.api.get(`gallery/list`, data);
  }
  // 获取所有Gallery信息
  // id
  async getgalleryInfo(data) {
    return this.api.get(`/gallery/get`, data);
  }
  // 填写个人简历提交并发送邮件至HR邮箱
  async postResumeInfo(data) {
    return this.api.post(`/mail/send`, data);
  }


 
  /**
   * create dataset
   * @param {String} spaceId
   * @param {Dataset} dataset
   *  dataset.name {String}
   *  dataset.description {String}
   *  dataset.dataType {String}
   *  dataset.importMethod {String}
   *  dataset.filePath {String}
   */
  async create(spaceId, dataset) {
    return this.api.post(`/spaces/${spaceId}/datasets`, dataset);
  }

}

export default new ModelService();
